import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const ContactPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 pb-24">
      {/* Header */}
      <div className="bg-white border-b sticky top-0 z-10">
        <div className="max-w-3xl mx-auto px-4 py-4 flex items-center gap-3">
          <button 
            onClick={() => navigate(-1)}
            className="p-2 hover:bg-gray-100 rounded-full transition-colors"
          >
            <ArrowLeft size={20} className="text-gray-600" />
          </button>
          <h1 className="text-xl font-bold text-[#1e3a5f]">Contact Us</h1>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-3xl mx-auto px-4 py-8">
        <div className="bg-white rounded-xl shadow-sm p-6 md:p-8 space-y-6">
          <p className="text-gray-600 leading-relaxed">
            We'd love to hear from you. Whether you have a question, feedback, a feature request, or want to report a bug, don't hesitate to reach out.
          </p>

          <div className="bg-amber-50 border border-amber-200 rounded-lg p-6 text-center">
            <p className="text-sm text-gray-500 mb-2">Email us at</p>
            <p className="text-xl font-semibold text-[#1e3a5f]">honeycookingcompanion@gmail.com</p>
          </div>

          <p className="text-gray-500 text-sm">
            We typically respond within 24 hours.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
